import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=6da3d244"
import script from "./Hero.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Hero.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports